import {
  PRODUCT_ARTICLE_CANVAS_HEIGHT,
  PRODUCT_ARTICLE_IMAGE_HEIGHT,
  PRODUCT_ARTICLE_IMAGE_WIDTH,
  PRODUCT_ARTICLE_TITLE_CLASS_NAME,
} from "./BookListingItem";
import { LiteraryWorkItem } from "../types";
import { getPageLink } from "@/navigation/selectors";
import classNames from "classnames";
import NextLink from "next/link";
import Image from "next/image";
import {
  BookStencil,
  Canvas,
  Link,
  Tag,
  Typography,
} from "@cappelendamm/design-system/react";
import { ListingItemProps } from "./types";

export function LiteraryWorkListingItem({
  item,
}: ListingItemProps<LiteraryWorkItem>) {
  const { objectID: sku, imageUrl, name, slug, subtitle } = item;
  const href = getPageLink({ pageType: "literaryWork", params: slug });
  return (
    <article
      className={classNames(
        "row-span-[var(--list-row-count)] grid min-w-0 grid-rows-subgrid gap-1 p-0",
        "active:rounded active:outline-3 active:outline-offset-4 active:outline-[var(--cvr-canvas-background)]",
      )}
    >
      <NextLink
        href={href}
        aria-labelledby={`item-${sku}`}
        className="group relative row-span-full grid min-w-0 grid-rows-subgrid no-underline"
      >
        <div className="row-start-1 -row-end-3 flex min-w-0 flex-col gap-1">
          <Canvas
            className="mb-1 px-2 py-2 md:px-6 md:py-2"
            style={{ height: PRODUCT_ARTICLE_CANVAS_HEIGHT }}
          >
            <div className="absolute top-0 left-0 flex flex-col gap-2 [&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:rounded-tr-md">
              <Tag variant={"informational"}>Læreverk</Tag>
            </div>
            {imageUrl ? (
              <Image
                src={imageUrl}
                className={classNames(
                  "h-full w-auto object-contain transition-transform",
                  "sm:group-hover:scale-102",
                )}
                alt={`Omslag fra verk "${name}"`}
                width={PRODUCT_ARTICLE_IMAGE_WIDTH * 3}
                height={PRODUCT_ARTICLE_IMAGE_HEIGHT}
                quality={100}
              />
            ) : (
              <div className="flex gap-2">
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
              </div>
            )}
          </Canvas>
          <Typography
            id={`item-${sku}`}
            as="h3"
            variant="title-md"
            className={classNames(PRODUCT_ARTICLE_TITLE_CLASS_NAME, {
              "sm:group-hover:underline": href,
            })}
          >
            {name}
          </Typography>
          <Typography
            as="p"
            variant="body-base"
            className="mt-0 block truncate"
            muted
          >
            {subtitle}
          </Typography>
        </div>
        <div className="-row-start-1 flex min-h-8 items-center self-start">
          <Link
            as="span"
            variant="inline"
            className="text-sm sm:group-hover:underline"
          >
            Se komponenter
          </Link>
        </div>
      </NextLink>
    </article>
  );
}
